export const TRANSIT_STOP_AMENITIES_VALUES = [
  'Sign/identifier',
  'Continuous sidewalk',
  'Shelter',
  'Lighting',
  'Realtime arrival display',
  'Trash receptacle',
  'Raised boarding platform',

  'Bench or seating',
  'Bike parking',
  'Detectable warning strip',
  'Adjacent crosswalk'
]
export const TRANSIT_STOP_AMENITIES = 'transit_stop_amenities'
export const HIGH_CAPACITY_TRANSIT_FACILITY = 'high_capacity_transit_facility'
export const HIGH_CAPACITY_TRANSIT_FACILITY_VALUES = [
  'Center running transit lanes',
  'Queue jump lanes',
  'Curbside transit lanes',
  'None'
]
export const HCT_AMENITIES = 'hct_amenities'
export const HCT_AMENITIES_VALUES = [
  'Transit signal priority',
  'Queue jump signage and pavement markings',
  'Offboard fare payment or pre-paid fare',
  'Colored pavement markings',
  'Curbside management accommodated through design',
  'Drive-ways and right turn conflicts are minimized',
  'Offboard fare payments or pre-paid fare',
  'Physical barrier between transit and traffic',
  'Left-turn conflicts are minimized',
  'Pedestrian crossing amenities at stop',
  'Offboard fare payments or pre-paid fare',
  'No traffic congestion along high-capacity transit corridor',
  'Turn conflicts at intersections and driveways are minimized',
  'Curbside management accommodated through design',
  'Offboard fare payments or pre-paid fare'
]
